import { checkoutStepsApi } from './index'

export default checkoutStepsApi.middleware
